import React, { useState } from 'react';
import { useAuth } from '../contexts/SupabaseAuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { AuthShell } from '../components/AuthShell';

export default function ResetPassword() {
  const { updatePassword, signOut, clearPasswordRecovery } = useAuth();
  const { language } = useLanguage();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError(language === 'es' ? 'Las contraseñas no coinciden' : 'Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError(
        language === 'es'
          ? 'La contraseña debe tener al menos 6 caracteres'
          : 'Password must be at least 6 characters'
      );
      return;
    }

    setLoading(true);
    try {
      await updatePassword(password);
      await signOut();
      setSuccess(true);
    } catch (err) {
      setError(err.message || (language === 'es' ? 'No se pudo cambiar la contraseña' : 'Could not change password'));
    }
    setLoading(false);
  };

  if (success) {
    return (
      <AuthShell title={language === 'es' ? '¡Contraseña actualizada!' : 'Password updated!'}>
        <p className="fp-msg fp-msg--ok">
          {language === 'es'
            ? 'Iniciá sesión de nuevo con tu contraseña nueva.'
            : 'Log in again with your new password.'}
        </p>
        <button className="fp-btn fp-btn--lg fp-btn--block" onClick={clearPasswordRecovery}>
          {language === 'es' ? 'Ir a Iniciar Sesión' : 'Go to Log In'}
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title={language === 'es' ? 'Elegí una contraseña nueva' : 'Choose a new password'}
      onSubmit={handleSubmit}
    >
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder={language === 'es' ? 'Contraseña nueva' : 'New password'}
        className="fp-input"
        required
        autoFocus
      />
      <input
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder={language === 'es' ? 'Confirmar contraseña' : 'Confirm password'}
        className="fp-input"
        required
      />

      {error && <div className="fp-msg fp-msg--error">{error}</div>}

      <button type="submit" className="fp-btn fp-btn--gold fp-btn--lg fp-btn--block" disabled={loading}>
        {loading ? '...' : language === 'es' ? 'Guardar contraseña' : 'Save password'}
      </button>
    </AuthShell>
  );
}
